import { useEffect, useState } from 'react'

import { AuthPageTemplate } from 'modules/auth/templates'
import loginBg from 'shared/assets/backgrounds/login-bg.webp'
import cyanOrangeBg from 'shared/assets/wallpapers/cyan-orange.webp'
import { CustomEvents, CustomEventsMap } from 'shared/constants/customEvents'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'
import { SessionStorageKey } from 'shared/constants/sessionStorage'
import { listenCustomEvent } from 'shared/utils/customEvents'

import { LoginMode, LoginModeType } from '../../LoginPage.types'
import { DeactivateTwoFa, OtpView } from '../../components'
import styles from './AuthView.module.scss'
import { LoginView } from './components'

export const AuthView = () => {
  const [loginMode, setLoginMode] = useState<LoginModeType>(LoginMode.Regular)
  const [mobileApprovalSessionId, setMobileApprovalSessionId] =
    useState<
      CustomEventsMap[CustomEvents.AUTH_LOGIN_REQUIRES_OTP]['mobileApprovalSessionId']
    >(null)
  useEffect(() => {
    const unsubscribe = listenCustomEvent(
      CustomEvents.AUTH_LOGIN_REQUIRES_OTP,
      event => {
        setLoginMode(LoginMode.Otp)
        setMobileApprovalSessionId(event.mobileApprovalSessionId)
      }
    )

    return unsubscribe
  }, [])

  const getAuthViewByLoginMode = () => {
    switch (loginMode) {
      case LoginMode.Otp:
        return (
          <OtpView
            mobileApprovalSessionId={mobileApprovalSessionId}
            setLoginMode={setLoginMode}
          />
        )
      case LoginMode.DeactivateOtp:
        return <DeactivateTwoFa />
      case LoginMode.Regular:
      default:
        return <LoginView loginMode={loginMode} setLoginMode={setLoginMode} />
    }
  }

  const handleBackButtonClick = () => {
    switch (loginMode) {
      case LoginMode.Otp:
      case LoginMode.DeactivateOtp:
        setLoginMode(LoginMode.Regular)
        sessionStorage.removeItem(SessionStorageKey.OTP_LOGGING_IN_EMAIL)
        sessionStorage.removeItem(SessionStorageKey.OTP_LOGGING_IN_PASSWORD)
        if (FEATURE_FLAGS.SHOW_REMEMBER_ME) {
          sessionStorage.removeItem(
            SessionStorageKey.OTP_LOGGING_IN_REMEMBER_ME
          )
        }
        break
      case LoginMode.Sso:
        setLoginMode(LoginMode.Regular)
        break

      default:
        break
    }
  }

  return (
    <AuthPageTemplate
      backgroundImageUrl={
        loginMode === LoginMode.Regular || loginMode === LoginMode.Sso
          ? loginBg
          : cyanOrangeBg
      }
      backButton={
        loginMode === LoginMode.Otp ||
        loginMode === LoginMode.DeactivateOtp ||
        loginMode === LoginMode.Sso
          ? {
              onClick: handleBackButtonClick
            }
          : undefined
      }
    >
      <div className={styles.content}>{getAuthViewByLoginMode()}</div>
    </AuthPageTemplate>
  )
}
